var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRename(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_101244)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33203 2.66675H2.66536C2.31174 2.66675 1.9726 2.80722 1.72256 3.05727C1.47251 3.30732 1.33203 3.64646 1.33203 4.00008V13.3334C1.33203 13.687 1.47251 14.0262 1.72256 14.2762C1.9726 14.5263 2.31174 14.6667 2.66536 14.6667H11.9987C12.3523 14.6667 12.6915 14.5263 12.9415 14.2762C13.1916 14.0262 13.332 13.687 13.332 13.3334V8.66675",
    stroke: "#353E5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.332 1.6669C12.5972 1.40168 12.957 1.25269 13.332 1.25269C13.7071 1.25269 14.0668 1.40168 14.332 1.6669C14.5972 1.93212 14.7462 2.29183 14.7462 2.6669C14.7462 3.04197 14.5972 3.40168 14.332 3.6669L7.9987 10.0002L5.33203 10.6669L5.9987 8.00023L12.332 1.6669Z",
    stroke: "#353E5A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_101244"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRename);
export default __webpack_public_path__ + "static/media/rename.330f8b8fe41a61e1c6e6fa8767c16cd1.svg";
export { ForwardRef as ReactComponent };